/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './BusinessVehicleInformation.module.scss'
import { changeObjectPropertyAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import { formatMasterNumber } from '../../../../shared/helpers/formatMasterNumber'

const MasterNumber = ({ t, i18n, validateMasterNumber, masterNumberValid, masterNumberError, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const masterNumber = useSelector((state) => state.app.businessVehicleInformation.masterNumber)

  const handleMasterNumber = (e) => {
    try {
      let masterNumberElem = e.currentTarget.value
      dispatch(changeObjectPropertyAction('businessVehicleInformation', 'masterNumber', masterNumberElem))
      validateMasterNumber(masterNumberElem)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurMasterNumber = (e) => {
    try {
      SetIsFocussed(false)
      if (RegExp(/^[a-zA-Z0-9 ]{10,14}$/i).test(e.currentTarget.value) && RegExp(/^[a-zA-Z]*$/i).test(e.currentTarget.value[0])) {
        const masterNum = formatMasterNumber(e.currentTarget.value)
        dispatch(changeObjectPropertyAction('businessVehicleInformation', 'masterNumber', masterNum))
        validateMasterNumber(masterNum)
      } else {
        dispatch(changeObjectPropertyAction('businessVehicleInformation', 'masterNumber', e.currentTarget.value.trim().toUpperCase()))
        validateMasterNumber(e.currentTarget.value.trim())
      }

    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const helpURL = i18n.language === "en"
    ? "https://support.novascotia.ca/services/address-changes#finding-master-number-permit"
    : "https://support.novascotia.ca/services/address-changes-fr#finding-master-number-permit"

  return (
    <div className={[
      masterNumberValid === true
        ? masterNumberValid === ''
          ? ''
          : 'form-group has-success'
        : masterNumberValid === false
          ? 'form-group has-error'
          : '',
      styles['fields_margin'],
    ].join(' ')}>
      <div className="ns-label-wrapper">
        <label className="ns-label" htmlFor="MasterNumber">
          <strong>{t('business_vehicle_info.master_number')}</strong>
        </label>
      </div>
      <div id="master-number-hint" className="ns-hint">
        {t('business_vehicle_info.you_can')}<a
          target="_blank"
          rel="noopener noreferrer"
          href={helpURL}
        >
          {' '}
          {t('business_vehicle_info.find_this_master')}
          <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
        </a>.
      </div>
      {(masterNumberValid === true || masterNumberValid === '') ? (
        null
      ) :
        (
          <span id="master-number-error" className={isFocussed ? 'help-block-focused' : 'help-block'}>
            <i aria-label={t('shared.error')} className="fa fa-exclamation-circle error-indicator errorAlert" aria-hidden="true"></i>
            <span className="ns-visually-hidden">{t('shared.error')}</span> {t(masterNumberError)}
          </span>
        )}
      <div style={{ display: "flex", overflow: "auto" }}>
        <input className={['fw-20',
          (masterNumberValid === true) ? 'ns-input--success' : '',
          (masterNumberValid !== true && masterNumberValid !== '') ? 'ns-input--error' : ''].join(' ')} id="MasterNumber" name="MasterNumber" type="text"
          aria-describedby="master-number"
          style={{ flexGrow: 1, minWidth: "3em" }}
          onChange={handleMasterNumber}
          onBlur={onBlurMasterNumber}
          onFocus={() => SetIsFocussed(true)}
          value={masterNumber}
          autoComplete="off"
          maxLength="14" />
        {(masterNumberValid === true) && (
          <div style={{ display: "inline-flex", marginLeft: "1rem", alignItems: "center" }}  ><i className="fa fa-check-circle fa-lg" aria-hidden="true"></i></div>
        )}
      </div>
    </div>
  )
}

export default withTranslation('common')(MasterNumber)